var PES = PES || {};
PES.PromoBanner = function () {

    //avoid page scroll being memorised and used on page refresh
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    let displayPromoBanner = function (pageUrl) {
        const hostname = new URL(pageUrl).hostname;
        const apiString = "/api/content-marketing-banner?state=live&locale";
        const banner = document.getElementById("top-promo-banner");
        const locale = banner.dataset.locale;
        const textContainer = document.getElementsByClassName('promo-banner__content--text')[0];
        const ctaButton = document.querySelector('[data-cta-button]');
        const ctaText = document.querySelector('[data-cta-text]');
        const ctaIcon = document.querySelector('[data-icon]');
        const closeButton = document.querySelector('[data-button-close]');
        let localStorageData = JSON.parse(localStorage.getItem("hideUtilityBanner"));

        const domain = hostname == "localhost" ? "localhost" : hostname.match(/([a-z0-9-]+\.[a-z]+)$/i)[0];

        let cmsHost = "";

        if (domain !== "officetimeline.com") {
            cmsHost = domain == "localhost" ? `http://localhost:1337${apiString}=${locale}` : `https://compass.pes-integration.com${apiString}=${locale}`
        } else {
            cmsHost = `https://compass.${domain}${apiString}=${locale}`
        }

        const router = { pathname: window.location.pathname };
        function hideUtilityBanner(data) {
            let bannerState = { hide: true, bannerData: null };

            function isPathInArray(paths) {
                const currentPath = router.pathname;
                return paths.some((path) => {
                    if (path.includes("*")) {
                        const basePath = path.replace("*", "");
                        return currentPath.startsWith(basePath);
                    }
                    return currentPath === path;
                });
            }

            data?.map((elem) => {
                if (elem) {
                    let visibleBanners = [];

                    // Iterate through all items and collect eligible banners
                    for (const item of data) {
                        const includePaths = item.includePaths?.split(/[\s,]+/).filter(Boolean) || [];
                        const excludePaths = item.excludePaths?.split(/[\s,]+/).filter(Boolean) || [];

                        const isRouteIncluded = includePaths.length > 0 ? isPathInArray(includePaths) : true;
                        const isRouteExcluded = excludePaths.length > 0 ? isPathInArray(excludePaths) : false;

                        if (isRouteIncluded && !isRouteExcluded) {
                            const wasDismissed = localStorageData?.find((obj) => obj.id === item.id);
                            let isEligible = true;
                            if (wasDismissed) {
                                isEligible = new Date(wasDismissed.dismissAt) < new Date(item.publishedAt);
                                if (isEligible) {
                                    // Remove old dismiss entries if republished
                                    const dataIds = new Set(item.localizations.map((loc) => loc.id)).add(item.id);
                                    localStorage.setItem("hideUtilityBanner", JSON.stringify(localStorageData.filter((obj) => !dataIds.has(obj.id))));
                                }
                            }

                            if (isEligible) {
                                visibleBanners.push(item);
                            }
                        }
                    }

                    // Pick the first banner in the sorted list to display
                    const visibleBannerData = visibleBanners.length > 0 ? visibleBanners[0] : null;
                    const isBannerVisible = !!visibleBannerData;

                    bannerState = { hide: !isBannerVisible, bannerData: visibleBannerData };
                } else {
                    bannerState = { hide: true, bannerData: null };
                }
            });            

            return bannerState;
        }
        function fetchData(apiUrl) {
            return fetch(apiUrl)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok ' + response.statusText);
                    }
                    return response.json();
                })
                .then(data => {
                    return data;
                })
                .catch(error => {
                    console.error('There was a problem with the fetch operation:', error);
                });
        }

        // Usage
        fetchData(cmsHost).then(data => {
            const bannerInfo = data?.banners;
            const { hide, bannerData } = hideUtilityBanner(bannerInfo);

            if (!bannerData) {
                return;
            }

            const { type, localizations, ctaArray, content } = bannerData;

            textContainer.innerHTML = content;
            ctaButton?.setAttribute("href", ctaArray[0]?.path);
            ctaArray[0]?.idAttr ? ctaButton?.setAttribute("id", ctaArray[0].idAttr) : null;
            ctaArray[0]?.openInNewTab ? ctaButton?.setAttribute("target", "_blank") : null;
            banner.setAttribute("data-banner-type", type);
            ctaText.innerText = ctaArray[0]?.label;
            ctaIcon.setAttribute("data-icon", type);

            banner.setAttribute("data-banner-is-visible", !hide);

            function closeBanner(id) {
                banner.setAttribute("data-banner-is-visible", false);
                setTimeout(function () {
                    banner.remove();
                }, 500);

                if (localStorageData === null) {
                    const newData = [];
                    newData.push({ id: id, dismissAt: new Date() });
                    //* If banner has translations hide them as well
                    if (localizations) {
                        localizations.map((elem) => {
                            newData.push({ id: elem.id, dismissAt: new Date() });
                        });
                        localStorage.setItem("hideUtilityBanner", JSON.stringify(newData));
                    }
                } else {
                    // Find the index of the object with the same id, if it exists
                    const existingIndex = localStorageData.findIndex((obj) => obj.id === id);
                    if (existingIndex > -1) {
                        // Update the dismissAt date of the existing object
                        localStorageData[existingIndex].dismissAt = new Date();
                    } else {
                        // Add the new object to the array
                        localStorageData.push({ id: id, dismissAt: new Date() });
                    }
                    localizations.map((elem) => {
                        const existingLocale = localStorageData.findIndex((obj) => {
                            if (obj.id === elem.id) {
                                return elem.id;
                            }
                        });
                        if (existingLocale > -1) {
                            localStorageData[existingLocale].dismissAt = new Date();
                        } else {
                            localStorageData.push({ id: elem.id, dismissAt: new Date() });
                        }
                    });
                    localStorage.setItem("hideUtilityBanner", JSON.stringify(localStorageData));
                }
            }

            function hideBanner() {
                closeBanner(bannerData.id);
                return function () {
                    closeButton.removeEventListener("click", hideBanner);
                }
            };

            closeButton.addEventListener("click", hideBanner)
        });
    }

    var init = function (envUrl) {
        displayPromoBanner(envUrl);
    };

    return {
        init: init
    };
}();